import { base64SimpleLabelPDF } from "./simple-warning-label-generation";

export function base64SSuffocationStickerPDF(widthInches: number, heightInches: number, copies: number = 1): string {
  const text = `WARNING: To avoid danger of suffocation, 
keep this plastic bag away from babies and 
children. Do not use this bag in cribs, beds, 
carriages or playpens.This bag is not a toy.`;

  return base64SimpleLabelPDF({
    widthInches: widthInches,
    heightInches: heightInches,
    text,
    copies,
  });
}
